<template>
  <div class="main-wrapper">
    <div class="login-page">
      <div class="login-body container">
        <div class="loginbox" style="padding-bottom: 0px">
          <div class="login-right-wrap">
            <div class="account-header">
              <div class="account-logo text-center mb-4">
                <router-link to="/">
                  <a href="/" class="text-lg" style="font-size: 26px">
                    <span
                      class="font-weight-600 text-slate-300"
                      :style="logoPrefixStyle"
                    >
                      {{ branding.logo.prefix }}
                    </span>
                    <span
                      class="font-weight-bold text-slate-500"
                      :style="logoSuffixStyle"
                    >
                      {{ branding.logo.suffix }}
                    </span>
                  </a>
                </router-link>
              </div>
            </div>
            <div class="login-header text-center">
              <h6 class="text-muted">Set Your Password</h6>
              <p v-if="invitationData" class="text-muted mt-2">
                Complete your registration for
                <strong>{{ invitationData.businessName }}</strong>
              </p>
              <div class="mt-4">
                <div
                  v-if="success === true && message"
                  class="alert alert-success"
                  role="alert"
                >
                  <strong>Success!</strong> {{ message }}
                </div>
                <div
                  v-if="success === false && message"
                  class="alert alert-danger"
                  role="alert"
                >
                  {{ message }}
                </div>
              </div>
            </div>

            <form class="vld-parent" ref="formContainer">
              <!-- Email (readonly) -->
              <div
                class="form-group"
                v-if="invitationData && invitationData.email"
              >
                <input
                  type="email"
                  class="form-control"
                  :value="invitationData.email"
                  readonly
                  disabled
                  style="background-color: #f5f5f5;"
                />
              </div>

              <!-- Password -->
              <div class="form-group" style="position: relative;">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  id="password"
                  required
                  v-model="password"
                  name="password"
                  placeholder="Enter your password"
                  autocomplete="new-password"
                />
                <button
                  class="btn"
                  style="position: absolute; top: 0; right: 0; margin-top: 2% !important;"
                  type="button"
                  @click="togglePassword($event)"
                >
                  <i v-if="showPassword" class="fa fa-eye mr-1"></i>
                  <i v-else class="fa fa-eye-slash mr-1"></i>
                </button>
              </div>

              <!-- Confirm Password -->
              <div class="form-group mb-4" style="position: relative;">
                <input
                  :type="showConfirmPassword ? 'text' : 'password'"
                  class="form-control"
                  id="confirmPassword"
                  required
                  v-model="confirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm your password"
                  autocomplete="new-password"
                />
                <button
                  class="btn"
                  style="position: absolute; top: 0; right: 0; margin-top: 2% !important;"
                  type="button"
                  @click="toggleConfirmPassword($event)"
                >
                  <i v-if="showConfirmPassword" class="fa fa-eye mr-1"></i>
                  <i v-else class="fa fa-eye-slash mr-1"></i>
                </button>
              </div>

              <div class="text-center">
                <button
                  class="btn btn-primary btn-block account-btn"
                  type="button"
                  @click="setPassword()"
                  :style="{
                    backgroundColor: branding.buttonColor,
                    color: branding.buttonTextColor,
                    borderColor: branding.buttonColor
                  }"
                  :disabled="loading"
                >
                  <span v-if="!loading">Set Password & Join</span>
                  <span v-else>
                    <i
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></i>
                  </span>
                </button>
                <button
                  class="btn btn-primary btn-block account-btn mt-2"
                  type="button"
                  @click="goBack()"
                  :style="{
                    backgroundColor: 'white',
                    color: branding.buttonColor,
                    borderColor: branding.buttonColor
                  }"
                >
                  Cancel
                </button>
              </div>
            </form>

            <div
              class="text-center dont-have mb-4"
              style="margin-top: 1rem !important;"
            >
              <div class="mt-3">
                <small id="terms-footnote" class="footnote">
                  {{ branding.footerText }}
                  <a
                    :href="branding.privacyPolicyUrl"
                    target="_blank"
                    :style="{ color: branding.primaryColor }"
                  >
                    privacy policy
                  </a>
                  and
                  <a
                    :href="branding.termsUrl"
                    target="_blank"
                    :style="{ color: branding.primaryColor }"
                  >
                    terms and conditions
                  </a>
                  that govern your usage of our services.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrandingByDomain } from "@/config/domainBranding";
import authServiceApi from "../../service/AuthServiceApi";

export default {
  name: "InvitationSetPassword",
  data() {
    return {
      success: null,
      message: "",
      password: "",
      confirmPassword: "",
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      invitationData: null,
      invitationId: null,
      branding: getBrandingByDomain(location.host)
    };
  },
  computed: {
    logoSuffixStyle() {
      return {
        color: this.branding.logo.suffixColor || "#ffffff",
        fontWeight: "bold",
        backgroundColor:
          this.branding.logo.suffixBackgroundColor ||
          this.branding.primaryColor,
        padding: "6px",
        borderRadius: "5px"
      };
    },
    logoPrefixStyle() {
      return {
        color: this.branding.logo.prefixColor || this.branding.secondaryColor
      };
    }
  },
  methods: {
    togglePassword(e) {
      e.preventDefault();
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword(e) {
      e.preventDefault();
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    goBack() {
      this.$router.push("/join-business");
    },
    validateForm() {
      if (!this.password) {
        this.success = false;
        this.message = "Password is required";
        return false;
      }
      if (this.password.length < 6) {
        this.success = false;
        this.message = "Password must be at least 6 characters";
        return false;
      }
      if (!this.confirmPassword) {
        this.success = false;
        this.message = "Please confirm your password";
        return false;
      }
      if (this.password !== this.confirmPassword) {
        this.success = false;
        this.message = "Passwords do not match";
        return false;
      }
      return true;
    },
    async setPassword() {
      if (!this.validateForm()) {
        return;
      }

      this.loading = true;
      this.success = null;
      this.message = "";

      try {
        const data = {
          password: this.password,
          confirmPassword: this.confirmPassword,
          domain: location.host
        };

        const response = await authServiceApi.acceptInvite(
          this.invitationId,
          data
        );

        if (response.data.code === "SUCCESS" || response.data.success) {
          // Clear session storage
          sessionStorage.removeItem("invitationData");

          // Navigate to success screen
          this.$router.push({
            name: "invitation-success",
            query: {
              businessName:
                (this.invitationData && this.invitationData.businessName) || "",
              email: (this.invitationData && this.invitationData.email) || ""
            }
          });
        } else if (response.data.code === "MEMBERSHIP_ALREADY_EXISTS") {
          sessionStorage.removeItem("invitationData");
          // Navigate to success screen with existing user flag
          this.$router.push({
            name: "invitation-success",
            query: {
              businessName:
                (this.invitationData && this.invitationData.businessName) || "",
              email: (this.invitationData && this.invitationData.email) || "",
              isExistingUser: "true"
            }
          });
        } else {
          this.success = false;
          this.message =
            response.data.description ||
            response.data.narrative ||
            "Failed to set password";
        }
      } catch (e) {
        console.error("Error setting password:", e);
        this.success = false;
        if (e.response && e.response.data) {
          this.message =
            e.response.data.narrative ||
            e.response.data.description ||
            "Failed to set password";
        } else {
          this.message = "Something went wrong. Please try again.";
        }
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    // Get invitation ID from route
    this.invitationId = this.$route.query.invitationId;

    // Get invitation data from session storage
    const storedData = sessionStorage.getItem("invitationData");
    if (storedData) {
      this.invitationData = JSON.parse(storedData);
    }

    // If no invitation data, redirect back
    if (!this.invitationId) {
      this.$router.push("/join-business");
    }
  }
};
</script>

<style scoped>
.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
  border: 0.1em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/auth/InvitationSetPassword.vue